module.exports = __webpack_public_path__ + "img/bg.c610b08c.png";